import { formatPeriodLabel, Period } from "./period";

// The grey line beside Export CSV and Email report on the Analytics tab says
// what the export holds: the page period, and the shipco the export sends
// (the one opened in the Shipcos table), else the whole fleet. Ruling
// 2026-10-30 keeps the export at "period + opened shipco"; this line makes
// that visible.
export function exportScopeText(
  period: Period,
  shipcoName: string | null
): string {
  const periodLabel = formatPeriodLabel(period);
  return shipcoName === null
    ? `Export covers ${periodLabel} for all shipcos.`
    : `Export covers ${periodLabel} for ${shipcoName}.`;
}
